import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const loadSaved = (storageKey) => {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && Array.isArray(parsed.agents) && Array.isArray(parsed.users)) {
        return parsed;
      }
    }
  } catch { /* ignore corrupt data */ }
  return { agents: [], users: [] };
};

const AgentFilterContext = createContext(null);

export const AgentFilterProvider = ({ storageKey, children }) => {
  const [filters, setFiltersState] = useState(() => loadSaved(storageKey));

  const setFilters = useCallback((next) => {
    const value = typeof next === 'function' ? next(filters) : next;
    setFiltersState(value);
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(value));
    } catch { /* quota exceeded — ignore */ }
  }, [filters, storageKey]);

  const value = useMemo(() => ({
    filters,
    setFilters,
  }), [filters, setFilters]);

  return (
    <AgentFilterContext.Provider value={value}>
      {children}
    </AgentFilterContext.Provider>
  );
};

export function useAgentFilters() {
  const context = useContext(AgentFilterContext);
  if (!context) {
    throw new Error('useAgentFilters must be used within an AgentFilterProvider');
  }
  return context;
}

export default AgentFilterContext;
